import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { UserRound } from "lucide-react";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import {
  selectColleagues,
  selectColleaguesInitializationStatus,
} from "../instructors-slice";
import { fetchColleagues } from "../slice-extensions/instructors-slice-extension";

interface AssignedInstructorRowProps {
  instructorId?: string;
}

/**
 * "Instructor" detail row for the session detail view. Renders only in a
 * multi-instructor organization (solo studios don't need to see themselves).
 */
const AssignedInstructorRow: React.FC<AssignedInstructorRowProps> = ({
  instructorId,
}) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const colleagues = useAppSelector(selectColleagues);
  const initStatus = useAppSelector(selectColleaguesInitializationStatus);

  useEffect(() => {
    if (initStatus === "not-initialized") {
      dispatch(fetchColleagues());
    }
  }, [dispatch, initStatus]);

  if (colleagues.length <= 1 || !instructorId) {
    return null;
  }

  const assigned = colleagues.find((c) => c.id === instructorId);
  if (!assigned) {
    return null;
  }

  return (
    <div className="flex items-center gap-4">
      <div className="flex items-center justify-center w-12 h-12 rounded-lg bg-grey-95 dark:bg-primary-90 shrink-0">
        <UserRound className="w-6 h-6 text-grey-30 dark:text-primary-40" />
      </div>
      <div className="flex-1">
        <p className="text-grey-30 dark:text-grey-70 text-sm">
          {t("instructors.assignedLabel", "Instructor")}
        </p>
        <p className="font-medium text-grey-10 dark:text-grey-90">
          {assigned.fullName}
        </p>
      </div>
    </div>
  );
};

export default AssignedInstructorRow;
